import React from "react";

const DefaultIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M3 3v18h18" />
    <path d="M7 14l3-3 4 4 5-7" opacity=".5" />
  </svg>
);

const EmptyState = ({
  title = "No data for this range",
  body = "Try adjusting the filters or expanding the date range.",
  icon,
}) => {
  return (
    <div className="rdc-state" role="status">
      <div className="rdc-state__icon">{icon || <DefaultIcon />}</div>
      <p className="rdc-state__title">{title}</p>
      <p className="rdc-state__body">{body}</p>
    </div>
  );
};

export default EmptyState;
